import * as moment from 'moment';

export function parseStringToDate(value: string, pattern: string = 'YYYY-MM-DD') : Date {
    return moment(value, pattern).toDate();
}

export function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function setDay(date, day) {
    var result = new Date(date);
    result.setDate(day);
    return result;
}

export function addMonths(date, months) {
    var result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return result;
}

export function setMonth(date, month) {
    var result = new Date(date);
    result.setMonth(month);
    return result;
}

export function addYears(date, years) {
    var result = new Date(date);
    result.setFullYear(result.getFullYear() + years);
    return result;
}
